export const BUNDLE_MAX_CUSTOMISATIONS = 2;
export const WEARER_BUNDLE_MAX_CUSTOMISATIONS = 1;
export const NOTES_MAX_LENGTH = 60;
export const FONT_PREVIEW_URL = '/fontpreview/preview/index';
